import React, { useMemo } from 'react';

import {
  Grid,
  Stack,
  View,
  Typography,
  Button,
  OpenInNewIcon,
} from '@gogame/components';
import { rangePresets } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

import PerformanceItem from './components/PerformanceItem';

const Performance = ({ id, type, data, isLoading, isRefetching, columns }) => {
  const nextDimension = useMemo(() => {
    switch (type) {
      case 'ConceptFamily':
        return 'Concept';
      case 'Concept':
        return 'CreativeFile';
      case 'CreativeFile':
        return 'Campaign';
      default:
        return '';
    }
  }, [type]);

  const gridSize = columns ? 12 / columns : 12;

  return (
    <View loading={isLoading} fetching={isRefetching}>
      <Grid container direction={'column'} p={2}>
        <Grid item>
          <Stack pb={2}>
            <Typography variant={'subtitle1'}>Last 30 Days Stats</Typography>
          </Stack>
        </Grid>
        {data ? (
          <Grid item container spacing={3} xs={12}>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.spend}
                label={'Spend'}
                type={'currency'}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.partnerCtv}
                label={'Partner CTV'}
                type={'percent'}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.partnerCvr}
                label={'Partner CVR'}
                type={'percent'}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.partnerCtr}
                label={'Partner CTR'}
                type={'percent'}
                precision={3}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.depositors}
                label={'Depositors %'}
                type={'percent'}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                value={data.roas}
                label={'ROAS'}
                type={'percent'}
              />
            </Grid>
            <Grid item xs={gridSize}>
              <PerformanceItem
                type={() => (
                  <Stack
                    justifyContent={'center'}
                    flex={'1 1 auto'}
                    whiteSpace={'noWrap'}
                    ml={-1}
                    mr={-1}
                  >
                    <ScreenLink
                      underline={'always'}
                      link={trackerLink}
                      target={'_blank'}
                      params={{
                        drillPath: [
                          { type: type, id },
                          { type: nextDimension },
                        ],
                        filtersCollection: [
                          { period: rangePresets.LAST_30_DAYS.value },
                        ],
                        ready: true,
                      }}
                    >
                      <Button icon={<OpenInNewIcon />} fullWidth={true}>
                        View all
                      </Button>
                    </ScreenLink>
                  </Stack>
                )}
              />
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </View>
  );
};

export default Performance;
